// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-markdown"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 5H23V19H1V5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M1 5H23V19H1V5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14 12.4975L16.5025 15L19.0031 12.4993M16.5025 9V14.2521M11 15V10C11 9.44772 10.5523 9 10 9L8 9M8 9L8 15M8 9L5 9L5 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LogoMarkdownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-markdown',
    ref,
    icon: element,
  },
));

LogoMarkdownIcon.displayName = 'LogoMarkdownIcon';

export default LogoMarkdownIcon;
